import consts from '../../../main/consts';

const json = {
  "origem": "SHIP_FROM_STORE",
  "tipoEntrega": "EXTERNA",
  "status": "NOVO_PEDIDO",
  "cliente": {
    "nome": "José Raimundos Alfredo",
    "cpf": "10164828419",
    "email": "ggl.123@lasa.com.br",
    "telefone": "(81)98814-1206",
    "endereco": "Avenida Barreto de Menezes 800",
    "numero": "800",
    "complemento": "",
    "bairro": "Piedade",
    "cidade": "Jaboatão dos Guararapes",
    "uf": "PE",
    "cep": "54410902"
  },
  "recebedor": {
    "nome": "Maria dos Santos",
    "documento": "10164828419"
  },
  "itemHash": "",
  "valorSubtotal": 18865.87,
  "valorTotal": 18865.87,
  "valorDesconto": 0,
  "valorEntrega": 0,
  "entregas": [{ "codigo": "999999" }],
  "itens": [{
    "codigoEAN": "7896012802410",
    "codigoSAP": "4138647",
    "descricao": "LENÇOS UMEDECIDOS POMPOM SUAVE C/50 UNIDADES",
    "peso": 1,
    "quantidadeImeis": 0,
    "quantidade": 608,
    "valorUnitario": 7.99,
    "valorTotal": 4857.92
  },
  {
    "codigoEAN": "7891350032741",
    "codigoSAP": "4242976",
    "descricao": "DESODORANTE BOZZANO AEROSSOL ANTITRANSPIRANTE FRESH 90G",
    "peso": 1,
    "quantidadeImeis": 0,
    "quantidade": 2004,
    "valorUnitario": 6.99,
    "valorTotal": 14007.96
  },
  ]
}

export function insertData(j) {

  const _j = JSON.parse(j);
  _j.debug = true;
  _j.loja = _j.loja || consts.DEBUG_LOJA;
  _j.numero = _j.numero || (Math.random() * (10 ** 5)).toFixed(0);
  _j.codigoExterno = _j.codigoExterno || `DEBUG_${(Math.random() * (10 ** 6)).toFixed(0)}`;

  return {
    integrationName: 'SHIP_FROM_STORE',
    type: 'NOVO_PEDIDO',
    data: _j,
  };
}

export function getNewOrderJSON() {
  return JSON.stringify(json, null, 2);
}